import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';
import { AppConfigurationService } from 'src/app/stp/stp-app/common';

@Injectable({
  providedIn: 'root'
})
export class AuditorGuard implements CanActivate, CanActivateChild {

  private auditorRole;

  constructor(
    private ssoAuthService: SsoAuthService,
    private router: Router,
    appConfig: AppConfigurationService) {
      this.auditorRole = appConfig.getValue('ssoAuditorRole');
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.isEcAuditor();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.isEcAuditor();
  }

  isEcAuditor(): boolean {
    if (this.ssoAuthService.hasAnyRoles(this.auditorRole)) {
      return true;
    }
    this.router.navigateByUrl('/auditorrolerequired');
    return false;
  }
}
